import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Chip from 'atoms/Chip'
import AddIcon from '@material-ui/icons/Add'
import ItemEditDialog from './ItemEditDialog'

export default class ScheduleEditorItemAdd extends Component {
  static propTypes = {
    onItemAdd: PropTypes.func.isRequired,
    weekDay: PropTypes.number.isRequired,
    addFormTitle: PropTypes.string.isRequired,
    editFormTitle: PropTypes.string.isRequired,
  }

  state = {
    dialogOpen: false
  }

  toggleDialog = () => {
    const { dialogOpen } = this.state
    this.setState({ dialogOpen: !dialogOpen })
  }

  handleSubmit = (items) => {
    const { onItemAdd } = this.props
    onItemAdd(items)
  }

  render() {
    const { weekDay, addFormTitle, editFormTitle } = this.props
    const { dialogOpen } = this.state
    return (
      <Fragment>
        <ItemEditDialog
          open={dialogOpen}
          onClose={this.toggleDialog}
          defaultWeekDay={weekDay}
          onSubmit={this.handleSubmit}
          addFormTitle={addFormTitle}
          editFormTitle={editFormTitle}
        />
        <Chip
          round
          disablePadding
          icon={AddIcon}
          onClick={this.toggleDialog}
        />
      </Fragment>
    )
  }
}
